import React from 'react';
import {v4 as uuidv4} from 'uuid';
import {
    CloseChat,
    IcoChat_A,
    IcoChat_B,
    IcoChat_C,
    IcoChat_D,
    IcoChat_E,
    BtnVideoIconOptions,
    IcoChat_F
} from '../iconsSvg'

export default function MessengerOptions(p) {
    const videoChatIconClick = () => {
        let spanDynamic = document.getElementById('sm-video-dynamic-id');
        if (spanDynamic) {
            const uuid = uuidv4();
            spanDynamic.setAttribute("data-dynamic-id", uuid);

            p.handleOpeningChat(true);
        }
    }

    return (
        <div className="sm-messengers-option">
            {p.visibleChat &&
            <ul className="zoomInUp animated">
                {window.VIDEO_CHAT &&
                <li
                    className="sm-video-chat-option"
                    onClick={() => videoChatIconClick()}
                    style={{backgroundColor: window.STYLE_MESSENGER_OPTION_ICON_BACKGROUND_COLOR_VIDEO_CHAT && window.STYLE_MESSENGER_OPTION_ICON_BACKGROUND_COLOR_VIDEO_CHAT !== '' ? window.STYLE_MESSENGER_OPTION_ICON_BACKGROUND_COLOR_VIDEO_CHAT : '#005ba8'}}
                >
                    {BtnVideoIconOptions}
                </li>}
                {window.VISIBLE_CHAT_ICON &&
                <li onClick={() => {
                    if(window.QUERY_PARAMS){
                        p.onSetParams(p.socketParams, p.sessionParentComponentParams, p.sendParams)
                    }
                    p.handleOpeningChat(true);
                }} className="sm-mess-opt-chat"
                    style={{backgroundColor: window.STYLE_MESSENGER_OPTION_ICON_BACKGROUND_COLOR_CHAT && window.STYLE_MESSENGER_OPTION_ICON_BACKGROUND_COLOR_CHAT !== '' ? window.STYLE_MESSENGER_OPTION_ICON_BACKGROUND_COLOR_CHAT : '#005ba8'}}>
                    {IcoChat_A} {p.visibleCounterNewMessage && p.oldCounterHistoryMessage > 0 &&
                <span className="sm-counterMessage">{p.oldCounterHistoryMessage}</span>}
                </li>}
                {window.LINK_TELEGRAM && window.LINK_TELEGRAM !== '' && <li
                    style={{backgroundColor: window.STYLE_MESSENGER_OPTION_ICON_BACKGROUND_COLOR_TELEGRAM && window.STYLE_MESSENGER_OPTION_ICON_BACKGROUND_COLOR_TELEGRAM !== '' ? window.STYLE_MESSENGER_OPTION_ICON_BACKGROUND_COLOR_TELEGRAM : '#005ba8'}}
                >
                    <a href={`https://telegram.me/${window.LINK_TELEGRAM}`} target="_blank">{IcoChat_C}</a>
                </li>}
                {window.LINK_VIBER && window.LINK_VIBER !== '' && <li
                    style={{backgroundColor: window.STYLE_MESSENGER_OPTION_ICON_BACKGROUND_COLOR_VIBER && window.STYLE_MESSENGER_OPTION_ICON_BACKGROUND_COLOR_VIBER !== '' ? window.STYLE_MESSENGER_OPTION_ICON_BACKGROUND_COLOR_VIBER : '#005ba8'}}
                >
                    <a href={`viber://pa?chatURI=${window.LINK_VIBER}`}>{IcoChat_E}</a>
                </li>}
                {window.LINK_FACEBOOK && window.LINK_FACEBOOK !== '' && <li
                    style={{backgroundColor: window.STYLE_MESSENGER_OPTION_ICON_BACKGROUND_COLOR_FACEBOOK && window.STYLE_MESSENGER_OPTION_ICON_BACKGROUND_COLOR_FACEBOOK !== '' ? window.STYLE_MESSENGER_OPTION_ICON_BACKGROUND_COLOR_FACEBOOK : '#005ba8'}}
                >
                    <a href={`http://m.me/${window.LINK_FACEBOOK}`}>{IcoChat_B}</a>
                </li>}
                {window.LINK_SKYPE && window.LINK_SKYPE !== '' && <li
                    style={{backgroundColor: window.STYLE_MESSENGER_OPTION_ICON_BACKGROUND_COLOR_SKYPE && window.STYLE_MESSENGER_OPTION_ICON_BACKGROUND_COLOR_SKYPE !== '' ? window.STYLE_MESSENGER_OPTION_ICON_BACKGROUND_COLOR_SKYPE : '#005ba8'}}
                >
                    <a href={`skype:${window.LINK_SKYPE}?chat`}>{IcoChat_D}</a>
                </li>}
                {window.LINK_INSTAGRAM && window.LINK_INSTAGRAM !== '' && <li
                    style={{background: window.STYLE_MESSENGER_OPTION_ICON_BACKGROUND_COLOR_INSTAGRAM && window.STYLE_MESSENGER_OPTION_ICON_BACKGROUND_COLOR_INSTAGRAM !== '' ? window.STYLE_MESSENGER_OPTION_ICON_BACKGROUND_COLOR_INSTAGRAM : '#005ba8'}}
                >
                    <a href={`https://www.instagram.com/${window.LINK_INSTAGRAM}`} target="_blank">{IcoChat_F}</a>
                </li>}
                <div onClick={() => p.handleVisibleChat(false)}
                     className="sm-option__close"
                >{CloseChat}</div>
            </ul>}
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/MessengerOptions/index.js